import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { BasicInformations } from '../models/basic-informations.model';

@Injectable({
    providedIn: 'root'
})
export class BasicInformationsService {
    private info: Subject<BasicInformations> = new BehaviorSubject<BasicInformations>(new BasicInformations({}));

    get info$() {
        return this.info.asObservable();
    }

    addInfo(basicInfo: BasicInformations) {
        this.info.next(basicInfo);
    }

}